<div class="top-bar">
  <ng-content></ng-content>
</div>
